import PropTypes from 'prop-types';
import React     from 'react';

export default function FeedPostBlur({isOverlay, imgUrl}) {
    if (!imgUrl) {
      return null;
    }
    return <div className="feed-blur__wrapper">
      <div className={"feed-blur" + (isOverlay ? " feed-blur--overlay" : "")}>
          <img className={"feed-blur__image" + (isOverlay ? " feed-blur__image--overlay" : "")} src={imgUrl} />
          <div className="feed-blur__overlay"></div>
      </div>
  </div>;
}

FeedPostBlur.propTypes = {
  imgUrl:    PropTypes.string,
  isOverlay: PropTypes.bool,
};